import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dispatch, AppState } from 'store/types'
import CmsForm from 'components/cms/CmsForm'
import {
  downloadCmsPdf,
  downloadCmsCsv,
  printCmsPdf,
} from 'ducks/cms/operations'
import { history, routePath } from 'routes'
import LogoTip from '../../components/UI/LogoTip/index.js'

class CmsReportPage extends Component<Props, {}> {
  goBack = () => {
    history.push(routePath.ESTIMATES_PAGE)
  }

  render() {
    console.log("CmsReportPage", this.props)

    return (
      <CenteredBlock>
        <LogoTip />
        <CmsForm
          // @ts-ignore
          onPdf={this.props.downloadCmsPdf}
          onCsv={this.props.downloadCmsCsv}
          onPrint={this.props.printCmsPdf}
          onBack={this.goBack}
        />
      </CenteredBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isFetchingCreate: state.cms.isFetchingCreate,
  isFetching: state.cms.isFetching,
  error: state.cms.error
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { downloadCmsPdf,
      downloadCmsCsv,
      printCmsPdf },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CmsReportPage)

const CenteredBlock = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`
